module.exports = __webpack_public_path__ + "static/media/Square.69bd7b78.png";